import {disableScrollingOnIos} from './Helpers';

export default class FilterSwitch {
	static instance = null;

	static create(options) {
		if (!FilterSwitch.instance) {
			FilterSwitch.instance = new FilterSwitch(options);
		}
		return FilterSwitch.instance;
	}

	static destroy() {
		if (FilterSwitch.instance) {
			FilterSwitch.instance.beforeDestroy();
			FilterSwitch.instance = null;
		}
	}

	get defaultOptions() {
		return {
			selector: null,
		};
	}

	constructor(options) {
		this.options = Object.assign({}, this.defaultOptions, options);

		this.filterOpener = this.options.selector.querySelector('.filter-opener')
		this.filterDrop = this.filterOpener?.nextElementSibling;
		this.breakpoint = window.matchMedia('(min-width:768px)');
		this.filterDiv = this.filterOpener?.parentNode;
		this.mobileFilter = document.querySelector('.filter-wrap');
		this.init();
	}

	init() {
		this.initFilterSwitch();
	}

	initFilterSwitch() {

		if (this.filterOpener) {
			this.filterOpener.addEventListener('click', (e) => {
				e.preventDefault();
				disableScrollingOnIos(()=>{
					document.body.classList.add('filter--active');
				});
			});
			const resizeHandler = () => {
				if (this.breakpoint.matches) {
					this.filterDiv.insertBefore(this.filterDrop, this.filterOpener);
				} else {
					document.body.append(this.filterDrop);
				}
			};
			this.breakpoint.addListener(resizeHandler);
			resizeHandler();
		}
	}

	beforeDestroy() {
		if (this.mobileFilter) {
			this.mobileFilter.remove();
		}
	}
}

